module.exports = __webpack_public_path__ + "img/bell.d528d76f.jpg";